import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { X } from "phosphor-react";
import { useState } from "react";
import { fpost } from "../../API/callsAPI";

const RemoveUserModal = ({
  handleClose,
  handleRefresh,
  userDetails,
  teamDetails,
  userType,
  selectedProject,
  setSnackValue,
}) => {
  const [isRemoving, setIsRemoving] = useState(false);
  const handleRemoveUser = async () => {
    try {
      setIsRemoving(true);
      const res = await fpost({
        url:
          userType === "team"
            ? `project-space/${teamDetails?.id}/remove-user/`
            : `project/${selectedProject?.id}/remove_user/`,
        data: {
          user: userDetails?.id,
        },
      });
      setSnackValue({
        isOpen: true,
        message: `SuccessFully Removed`,
        isError: false,
      });
      setIsRemoving(false);
      handleRefresh();
    } catch (error) {
      setIsRemoving(false);
      setSnackValue({
        isOpen: true,
        message: `${error}`,
        isError: true,
      });
    }
  };
  return (
    <Box
      sx={{
        backgroundColor: "#1B1D28",
        borderRadius: "20px",
        width: "500px",
        padding: "24px",
        color: "#F9F9F9",
        fontFamily: "Poppins",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          // alignItems: "center",
          gap: "24px",
          textAlign: "center",
        }}
      >
        {/* Header with icon and title */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <Typography fontSize={24} fontWeight={500} fontFamily="Poppins">
            Remove confirmation
          </Typography>
        </Box>

        {/* Confirmation text */}
        <Typography
          sx={{
            fontSize: "14px",
            textAlign: "left",
            fontFamily: "Poppins",
          }}
        >
          Are you sure you want to remove this user from this{" "}
          {userType === "team" ? "Team" : "project"}
        </Typography>

        {/* User info */}
        {userDetails && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              // alignItems: "center",
              gap: "8px",
              bgcolor: "#252A38",
              padding: "12px",
              borderRadius: "9px",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <Box
                sx={{
                  width: "30px",
                  height: "30px",
                  backgroundColor: "#6C65D9",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "12px",
                  fontWeight: 500,
                  color: "black",
                }}
              >
                {userDetails?.first_name[0]
                  ? userDetails?.first_name[0].toUpperCase()
                  : "KR"}
              </Box>
              <Box>
                <Typography
                  sx={{
                    color: "#fff",
                    fontSize: "16px",
                    fontWeight: 500,
                    textAlign: "left",
                    fontFamily: "Poppins",
                  }}
                >
                  {userDetails.first_name || "Kashyap Rayas"}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    textAlign: "left",
                    color: "#606479",
                    fontFamily: "Poppins",
                  }}
                >
                  {userDetails.email || "kashyap@vigaet.com"}
                </Typography>
              </Box>
            </Box>
          </Box>
        )}

        {/* Action buttons */}
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: "16px",
          }}
        >
          <Button
            onClick={handleClose}
            startIcon={<X size={18} />}
            sx={{
              backgroundColor: "transparent",
              color: "#fff",
              border: "2px solid #6C65D9",
              borderRadius: "12px",
              padding: "12px 24px",
              fontSize: "14px",
              textTransform: "none",
              minWidth: "150px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              "&:hover": {
                backgroundColor: "rgba(108, 101, 217, 0.1)",
              },
            }}
            disabled={isRemoving}
          >
            Cancel
          </Button>
          <Button
            onClick={handleRemoveUser}
            sx={{
              backgroundColor: "#D61F1F",
              color: "#fff",
              borderRadius: "10px",
              padding: "12px 24px",
              fontSize: "14px",
              textTransform: "none",
              minWidth: "150px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              "&:hover": {
                backgroundColor: "#B91C1C",
              },
              "&:disabled": {
                backgroundColor: "#363232ff",
              },
            }}
            disabled={isRemoving}
          >
            {isRemoving ? <CircularProgress size={20} /> : "Remove User"}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default RemoveUserModal;
